import { render, staticRenderFns } from "./SurveyEditDialog.vue?vue&type=template&id=b04cc312&scoped=true&"
import script from "./SurveyEditDialog.vue?vue&type=script&lang=js&"
export * from "./SurveyEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./SurveyEditDialog.vue?vue&type=style&index=0&id=b04cc312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04cc312",
  null
  
)

export default component.exports